import { ChangeEvent } from 'react'
import { IOProps } from 'react-compose-io'
import { Acao, Condicao } from '../../../types/regraApiType'
import { GrupoRegra } from '../../../types/transformacaoApiTypes'
import { FieldsAcaoTransformacaoApi } from '../FieldsAcaoTransformacaoApi/index'
import { FieldsCondicaoTransformacaoApi } from '../FieldsCondicaoTransformacaoApi'
import { FieldsDescricao } from '../FieldsDescricao/index'
import { FormularioRegraTransformacaoApiIO } from './FormularioRegraTransformacaoApi.IO'
import { FieldsDescricaoNotaFiscal } from '../FieldsDescricaoNotaFiscal'

type FormularioRegraProps = {
  mudarStatusParaAtivo?: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void
  ativo?: boolean
  isEdicao?: boolean
  condicaoLista: Condicao[]
  acaoLista: Acao[]
  grupoRegraLista: GrupoRegra[] | null
  cabecalhosPlanilha: string[]
}

export function FormularioRegraTransformacaoApiView({
  mudarStatusParaAtivo,
  ativo,
  condicaoLista,
  acaoLista,
  grupoRegraLista,
  cabecalhosPlanilha,
  isEdicao
}: IOProps<FormularioRegraTransformacaoApiIO, FormularioRegraProps>) {
  return (
    <>
      {grupoRegraLista != null ? (
        <FieldsDescricao isEdicao={isEdicao} grupoRegraLista={grupoRegraLista ?? []} mudarStatusAtivo={mudarStatusParaAtivo} ativo={ativo} />
      ) : (
        <FieldsDescricaoNotaFiscal isEdicao={isEdicao} mudarStatusAtivo={mudarStatusParaAtivo} ativo={ativo} />
      )}

      <FieldsCondicaoTransformacaoApi itensCampo={condicaoLista} cabecalhos={cabecalhosPlanilha} />
      <FieldsAcaoTransformacaoApi itensCampo={acaoLista} cabecalhos={cabecalhosPlanilha} />
    </>
  )
}
